export default function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <span className="brand" aria-label="Connections with Friends">
      <svg className="brand-mark" viewBox="0 0 48 48" role="img" aria-label="A colourful four by four puzzle grid">
        <g stroke="currentColor" strokeWidth="2.4" strokeLinejoin="round">
          <path fill="#ffd735" d="M3 4h9v9H3zM15 4h9v9h-9zM27 4h9v9h-9zM39 4h6v9h-6z" />
          <path fill="#ff675d" d="M3 16h9v9H3zM15 16h9v9h-9zM27 16h9v9h-9zM39 16h6v9h-6z" />
          <path fill="#55b9e8" d="M3 28h9v9H3zM15 28h9v9h-9zM27 28h9v9h-9zM39 28h6v9h-6z" />
          <path fill="#a17be8" d="M3 40h9v5H3zM15 40h9v5h-9zM27 40h9v5h-9zM39 40h6v5h-6z" />
        </g>
      </svg>
      {compact ? null : <span className="brand-name">Connections <em>with</em> Friends</span>}
    </span>
  );
}
